export const DEPRECATED_APPOINTMENT_TYPES = [
  "CCS_MED_CONSULT",
  "ONBOARDING_PROVIDER_VISIT",
  "ONBOARDING_SPECIALIST"
] as const;

export type DeprecatedAppointmentType =
  (typeof DEPRECATED_APPOINTMENT_TYPES)[number];

export const isDeprecatedAppointmentType = (
  appointmentType?: string | null
): appointmentType is DeprecatedAppointmentType => {
  if (!appointmentType) {
    return false;
  }

  return DEPRECATED_APPOINTMENT_TYPES.includes(
    appointmentType as DeprecatedAppointmentType
  );
};
